// components/Admin/MiniroomManager/index.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Box, Paper, Tabs, Tab, Button, useTheme, useMediaQuery } from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import api from "../../../api/axios";
import MiniroomFurnitureTable from "./MiniroomFurnitureTable";
import MiniroomFurnitureFormModal from "./MiniroomFurnitureFormModal";
import BackgroundTable from "./BackgroundTable";
import BackgroundFormModal from "./BackgroundFormModal";

export default function MiniroomManager() {
    const [furnitures, setFurnitures] = useState([]);
    const [backgrounds, setBackgrounds] = useState([]);
    const [openFurniture, setOpenFurniture] = useState(false);
    const [openBackground, setOpenBackground] = useState(false);
    const [bgToEdit, setBgToEdit] = useState(null); // ★ 추가: 수정 대상
    const [tab, setTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    // 가구 불러오기
    const fetchFurnitures = useCallback(async () => {
        try {
            const { data } = await api.get("/api/miniroom/admin/furnitures/");
            setFurnitures(Array.isArray(data) ? data : data?.results ?? []);
        } catch (e) {
            console.error(e);
        }
    }, []);

    // 패턴 불러오기
    const fetchBackgrounds = useCallback(async () => {
        const { data } = await api.get("/api/miniroom/admin/backgrounds/");
        setBackgrounds(Array.isArray(data) ? data : data?.results ?? []);
    }, []);

    useEffect(() => {
        fetchFurnitures();
        fetchBackgrounds();
    }, [fetchFurnitures, fetchBackgrounds]);

    return (
        <Box sx={{ p: isMobile ? 2 : 4 }}>
            <Paper elevation={2} sx={{ mb: 2, borderRadius: 2, px: 1 }}>
                <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="fullWidth">
                    <Tab label="가구 등록/노출 관리" />
                    <Tab label="배경 관리" />
                </Tabs>
            </Paper>

            <Box display="flex" justifyContent={isMobile ? "center" : "flex-end"} mb={2}>
                {tab === 0 ? (
                    <Button
                        variant="contained"
                        startIcon={<AddPhotoAlternateIcon />}
                        onClick={() => setOpenFurniture(true)}
                        fullWidth={isMobile}
                    >
                        + 가구 등록
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        startIcon={<AddPhotoAlternateIcon />}
                        onClick={() => { setBgToEdit(null); setOpenBackground(true); }}
                        fullWidth={isMobile}
                    >
                        + 배경 등록
                    </Button>
                )}
            </Box>

            {tab === 0 ? (
                <>
                    <MiniroomFurnitureTable items={furnitures} refresh={fetchFurnitures} />
                    <MiniroomFurnitureFormModal open={openFurniture} onClose={() => setOpenFurniture(false)} onSuccess={fetchFurnitures} />
                </>
            ) : (
                <>
                    <BackgroundTable
                        items={backgrounds}
                        refresh={fetchBackgrounds}
                        onEdit={(item) => { setBgToEdit(item); setOpenBackground(true); }}
                    />
                    <BackgroundFormModal
                        open={openBackground}
                        initial={bgToEdit}
                        onClose={() => { setOpenBackground(false); setBgToEdit(null); }}
                        onSuccess={fetchBackgrounds}
                    />
                </>
            )}
        </Box>
    );
}
